import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    const handleClickOutside = (e: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-268">
      <div ref={modalRef} className="relative w-full max-w-2xl max-h-[80vh] bg-white rounded-lg shadow-lg overflow-hidden flex flex-col" data-id="element-269">
        <div className="flex items-center justify-between p-4 border-b border-amber-100 bg-amber-50" data-id="element-270">
          <h2 className="text-xl font-serif font-bold text-amber-900" data-id="element-271">
            {title}
          </h2>
          <button onClick={onClose} className="text-amber-800 hover:text-amber-600 transition-colors" aria-label="Cerrar" data-id="element-272">
            <XIcon size={24} data-id="element-273" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto" data-id="element-274">{children}</div>
        <div className="p-4 border-t border-amber-100 bg-amber-50 text-center" data-id="element-275">
          <button onClick={onClose} className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-medium rounded-md transition-colors" data-id="element-276">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}